<template>
  <!-- <b-row class="text-center"> -->
    <b-col md="3" sm="3" xl="3" class="animated fadeIn fadeOut">
      <b-card @click="detail(agent)" :style="{ cursor: 'pointer'}">
        <h4>
          <b-badge :variant="agent.fqdn ? 'info' : 'primary'">
            {{agent.fqdn ? 'ドメイン' : 'サーバー'}}
          </b-badge>
        </h4>
        <hr>
        <p class="ml-2 font-weight-bold">{{agent.name || '-'}}</p>
        <h6>{{agent.fqdn ? agent.fqdn : agent.ip_addr}}<br></h6>
        <hr>
        <b-badge v-if="agent.total_detect" variant="danger" @click="$router.push({ name : 'integrity_detect' })">最近の検出 : {{agent.total_detect}}</b-badge>
        <b-badge v-else-if="!agent.is_configured" variant="dark">構成ではありません</b-badge>
        <b-badge v-else variant="success">Good</b-badge>
      </b-card>
    </b-col>

  <!-- </b-row> -->
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
